var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgAppusers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213bc8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8359",
    "data-name": "Group 8359",
    transform: "translate(4601 -14154)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 49,
    cy: 49,
    r: 49,
    transform: "translate(-4601 14154)",
    fill: "#213bc8",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7179",
    "data-name": "Group 7179",
    transform: "translate(-5021.391 12139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7161",
    "data-name": "Path 7161",
    d: "M-3.647-23.423a5.424,5.424,0,0,0,2.228-.469A5.5,5.5,0,0,0,.412-25.123a6.211,6.211,0,0,0,1.246-1.847,5.808,5.808,0,0,0,.44-2.257,5.734,5.734,0,0,0-.44-2.228A6.211,6.211,0,0,0,.412-33.3,5.5,5.5,0,0,0-1.42-34.531,5.424,5.424,0,0,0-3.647-35a5.424,5.424,0,0,0-2.228.469A5.5,5.5,0,0,0-7.707-33.3a6.211,6.211,0,0,0-1.246,1.847,5.734,5.734,0,0,0-.44,2.228,5.808,5.808,0,0,0,.44,2.257,6.211,6.211,0,0,0,1.246,1.847,5.5,5.5,0,0,0,1.832,1.231A5.424,5.424,0,0,0-3.647-23.423Zm0,1.231a10.411,10.411,0,0,0-4.25.879,11.1,11.1,0,0,0-3.5,2.374,11.409,11.409,0,0,0-2.359,3.517,11.006,11.006,0,0,0-.85,4.309,2.292,2.292,0,0,0,.689,1.685,2.292,2.292,0,0,0,1.685.689H4.94a2.292,2.292,0,0,0,1.685-.689,2.292,2.292,0,0,0,.689-1.685,11.006,11.006,0,0,0-.85-4.309,11.409,11.409,0,0,0-2.359-3.517A11.1,11.1,0,0,0,.6-21.312,10.411,10.411,0,0,0-3.647-22.192Z",
    transform: "translate(479.295 2086.369)",
    opacity: 0.7,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7160",
    "data-name": "Path 7160",
    d: "M0-19.57A7.229,7.229,0,0,0,2.969-20.2,7.332,7.332,0,0,0,5.41-21.836,8.277,8.277,0,0,0,7.07-24.3,7.741,7.741,0,0,0,7.656-27.3a7.642,7.642,0,0,0-.586-2.969,8.277,8.277,0,0,0-1.66-2.461,7.332,7.332,0,0,0-2.441-1.641A7.229,7.229,0,0,0,0-35a7.229,7.229,0,0,0-2.969.625A7.332,7.332,0,0,0-5.41-32.734a8.277,8.277,0,0,0-1.66,2.461A7.642,7.642,0,0,0-7.656-27.3,7.741,7.741,0,0,0-7.07-24.3a8.277,8.277,0,0,0,1.66,2.461A7.332,7.332,0,0,0-2.969-20.2,7.229,7.229,0,0,0,0-19.57ZM0-17.93a13.876,13.876,0,0,0-5.664,1.172,14.8,14.8,0,0,0-4.668,3.164,15.205,15.205,0,0,0-3.145,4.688,14.668,14.668,0,0,0-1.133,5.742,3.055,3.055,0,0,0,.918,2.246A3.055,3.055,0,0,0-11.445,0H11.445a3.055,3.055,0,0,0,2.246-.918,3.055,3.055,0,0,0,.918-2.246,14.668,14.668,0,0,0-1.133-5.742,15.205,15.205,0,0,0-3.145-4.687,14.8,14.8,0,0,0-4.668-3.164A13.876,13.876,0,0,0,0-17.93Z",
    transform: "translate(466 2082)",
    fill: "url(#linear-gradient)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppusers);
export default __webpack_public_path__ + "static/media/appusers.fccfb07f0a665bdac42e15e41308f8e4.svg";
export { ForwardRef as ReactComponent };